const core = {
  // IDとFormID
  id: 698,
  form_id: 1,

  // EFOcats化するフォームのセレクタ
  formQuery: 'form',

  // フォームの中でのページ区切り
  pageQuery: '.form__group',

  // ページから中設問を取得するクエリ
  questionQuery: '.form__group-label',

  // EFOcatsの設置先
  targetQurey: 'body',

  // 送信ボタン
  submitbtnQuery: 'form [type="submit"]',

  // 先頭ページに戻るボタンを作成するか
  pager_back: false,

  // 先頭ページの戻るボタンをクリックした時に元画面のどのボタンをクリックするか
  pager_back_selector: '',

  // 先頭ページの戻るボタンをクリックした時の遷移先URL
  pager_back_url: '',

  // EFOcats起動後何ミリ秒以内で起動しなければロールバックするか
  rollbackTime: 5000,

  // 許可デバイス
  AllowDevices: ['PC', 'SP'],

  // OSの最低バージョン
  AndoroidVer: 7,
  iOSVer: 11,

  // パスワードのルール
  PasswordMinLength: 0,
  PasswordMaxLength: 0,
  PasswordPattern: [],

  // 大設問（0から始まるページ番号:テキスト）
  titleList: {},

  // 大設問下の注意書き（0から始まるページ番号:テキスト）
  infoList: {},

  // 設問下の注意書き（0から始まるページ番号:テキスト）
  attentionList: {},

  // 中設問（name属性:テキスト）
  labelList: {},

  // アコーディオン
  accordionList: {},

  // 自動取り込み対象の入力欄の属性
  importAttrs: [],

  // モーダルを開く要素のセレクタ
  modalOpenItem: '',

  // モーダルの設置先
  modalTargetQuery: '',
};

export default core;
